// Centralised environment config — all env-driven URLs in one place

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID || 'ap-southeast-2_OBwNDclm6';
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID || '49vd458pma3njh1al6t6uke2er';
export const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN || 'bytesized.auth.ap-southeast-2.amazoncognito.com';
